import React from "react";
import { useRecommendation } from "../../../contexts/use-recommendation";

function RecommendationFeedbackFullRecommendationPage() {
    const recommendationContext = useRecommendation();
    const { setCurrentPage } = recommendationContext;

    function handleNoMember() {
        setCurrentPage(1);
    }

    return (
        <div>
            <div className="mb-8 mt-5 text-center">
                <p>Você já enviou a quantidade máxima de indicações.</p>
                <p>Para fazer novas indicações procure um dos pastores da Igreja.</p>
            </div>
            <div className="text-center">
                <button type="button" className="bg-gray-700 transform hover:scale-105 transition duration-500 opacity-75 text-white py-3 px-8 rounded mr-4" onClick={handleNoMember}>Voltar</button>
            </div>
        </div>
    )
}

export default RecommendationFeedbackFullRecommendationPage;

